
import service from '../index'
import config from '@/assets/config.json'


/**
 * @亲子项目功能设置预约日历
 * 
 * @config.babyHttps.api 
 */
const token = localStorage.getItem('Beitoken')

// 获取日历列表
export function getDateList(params) {
  const url = config.babyHttps.api + '/apitravel/admin/calendar/list'
//   return service.get(url, data)
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 创建/修改日历信息
export function setDate(params) {
    const url = config.babyHttps.api + '/apitravel/admin/calendar/set'
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 删除日历
export function deleteDate(params) {
    const url = config.babyHttps.api + '/apitravel/admin/calendar/delete'
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}


